// import React, { useEffect, useState, useMemo } from "react";
// import "./Usermanagement.css"; // Import the CSS file
// import { Link } from "react-router-dom";
// import ProfessionalUser from "./ProfessionalUser";
// import PostPaidUsers from "./PostPaidUsers";

// const Userdetails = () => {
//     const [selectedCustomer, setSelectedCustomer] = useState(null);
//     const [data, setData] = useState([]);
//     const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//     const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
//     const [selectedCategoryFilter, setSelectedCategoryFilter] = useState("");
//     const [activeTab, setActiveTab] = useState("User"); // New tab state

//     // Tab content mapping
//     const tabContent = {
//         "User": <UserTabContent 
//             data={data}
//             selectedStatusFilter={selectedStatusFilter}
//             setSelectedStatusFilter={setSelectedStatusFilter}
//             selectedCategoryFilter={selectedCategoryFilter}
//             setSelectedCategoryFilter={setSelectedCategoryFilter}
//             filteredData={useMemo(() => {
//                 return data.filter(user => {
//                     const statusMatch = !selectedStatusFilter ||
//                         user.active === (selectedStatusFilter === "true");
//                     const categoryMatch = !selectedCategoryFilter ||
//                         (user.category && user.category.toLowerCase() === selectedCategoryFilter.toLowerCase());
//                     return statusMatch && categoryMatch;
//                 });
//             }, [data, selectedStatusFilter, selectedCategoryFilter])}
//             handleExport={() => {
//                 if (data.length === 0) {
//                     alert("There is no data to export.");
//                     return;
//                 }

//                 const escapeCsvField = (field) => {
//                     const str = String(field ?? '');
//                     if (str.includes(',') || str.includes('"') || str.includes('\n')) {
//                         return `"${str.replace(/"/g, '""')}"`;
//                     }
//                     return str;
//                 };

//                 const headers = [
//                     "S.NO",
//                     "Customer ID",
//                     "Name",
//                     "Email",
//                     "Category",
//                     "Subscription",
//                     "Phone Number",
//                     "Total Orders",
//                     "Last Order Date",
//                     "Status"
//                 ];

//                 const csvRows = data.map((user, index) => [
//                     index + 1,
//                     user.userId || 'N/A',
//                     user.userName || 'N/A',
//                     user.emailId || 'N/A',
//                     user.category || 'N/A',
//                     user.subscription || 'N/A',
//                     user.mobileNumber || 'N/A',
//                     user.orders !== undefined ? user.orders : 'N/A',
//                     user.last || 'N/A',
//                     user.statusAsDeliveryAgent || 'N/A'
//                 ]);

//                 const csvString = [
//                     headers.map(escapeCsvField).join(','),
//                     ...csvRows.map(row => row.map(escapeCsvField).join(','))
//                 ].join('\r\n');

//                 const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
//                 const url = URL.createObjectURL(blob);
//                 const link = document.createElement("a");
//                 link.setAttribute("href", url);
//                 link.setAttribute("download", "users.csv");
//                 document.body.appendChild(link);
//                 link.click();
//                 document.body.removeChild(link);
//                 URL.revokeObjectURL(url);
//             }}
//         />,
//         "Professional User": <ProfessionalUser />, // Using the imported component
//         "Post Paid Users": <PostPaidUsers />, // New tab for Post Paid Users
//     };

//     useEffect(() => {
//         const handleResize = () => setScreenWidth(window.innerWidth);
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//    useEffect(() => {
//     const controller = new AbortController();
//     const authToken = localStorage.getItem("authToken");

//     const fetchUsers = async () => {
//         try {
//             const res = await fetch(
//                 "https://backend.maamaas.com/subscription/api/admin/getallusers",
//                 {
//                     signal: controller.signal,
//                     headers: {
//                         "Content-Type": "application/json",
//                         "Authorization": `Bearer ${authToken}`,
//                     },
//                 }
//             );

//             if (!res.ok) {
//                 throw new Error(`HTTP error! status: ${res.status}`);
//             }

//             const fetchedData = await res.json();

//             // ✅ FILTER ONLY PERSONAL USERS
//             const personalUsers = fetchedData.filter(
//                 (item) => item.userType === "PERSONAL"
//             );

//             const dataWithSno = personalUsers.map((item, index) => ({
//                 ...item,
//                 sno: index + 1,
//                 category: item.category || "N/A",
//                 subscription: item.subscription || "N/A",
//                 orders: typeof item.orders === "number" ? item.orders : 0,
//                 last: item.lastOrderDate || item.last || "N/A",
//                 statusAsDeliveryAgent:
//                     item.status || item.statusAsDeliveryAgent || "N/A",
//             }));

//             setData(dataWithSno);
//         } catch (err) {
//             if (err.name !== "AbortError") {
//                 console.error("Error fetching users:", err);
//             }
//         }
//     };

//     fetchUsers();

//     return () => controller.abort();
// }, []);

//     const openModal = (user) => setSelectedCustomer(user);
//     const closeModal = () => setSelectedCustomer(null);

//     return (
//         <div className="container-fluid p-0 client-managment-data">
//             <div className="row g-0" style={{ marginTop: '90px', height: "92vh" }}>
//                 <div className="col-lg-2"></div>
//                 <div className="col-lg-10">
//                     <p
//                         className="breadcrumb maamaas-home-bredcum or20"
//                         style={{
//                             position: "fixed",
//                             top: "59px",
//                             left: "1vw",
//                             width: "100%",
//                             backgroundColor: "#fff",
//                             padding: "10px 0",
//                             fontSize: "18px",
//                             fontWeight: "bold",
//                             textAlign: "center",
//                             margin: 0,
//                         }}
//                     >
//                         <Link
//                             to="/Homes"
//                             style={{
//                                 color: "purple",
//                                 fontWeight: "bold",
//                                 textDecoration: "none",
//                             }}
//                         >
//                             Home
//                         </Link>

//                         <span className="separator"> &gt; </span>
//                         <span
//                             style={{
//                                 color: "purple",
//                                 fontWeight: "bold",
//                                 textDecoration: "none",
//                             }}
//                         >
//                             User_Management
//                         </span>
//                         <span className="separator"> &gt; </span>
//                         <span
//                             style={{
//                                 color: "purple",
//                                 fontWeight: "bold",
//                                 textDecoration: "none",
//                             }}
//                         >
//                             {activeTab === "User" ? "Users" : activeTab === "Professional User" ? "Professionals" : "Post Paid Users"}
//                         </span>
//                     </p>
                    
//                     {/* Tab Buttons Container - Fixed position */}
//                     <div className="sticky-top py-1 px-1" style={{ top: '66px' }}>
//                         <div className="row g-2 justify-content-center justify-content-sm-evenly">
//                             {Object.keys(tabContent).map((label) => (
//                                 <div className="col-auto" style={{ minWidth: '100px' }} key={label}>
//                                     <button
//                                         onClick={() => setActiveTab(label)}
//                                         style={{
//                                             border: "none",
//                                             borderRadius: "10px",
//                                             minWidth: "140px",
//                                             width: "100%",
//                                             padding: "0 10px",
//                                             height: "40px",
//                                             backgroundColor: activeTab === label ? "#b15cd6" : "#d9d9d9",
//                                             color: activeTab === label ? "#fff" : "#000",
//                                             fontWeight: "bold",
//                                             cursor: "pointer",
//                                             transition: "background-color 0.3s ease",
//                                             fontSize: "1rem",
//                                         }}
//                                     >
//                                         {label}
//                                     </button>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>

//                     {/* Tab Content Container - Scrollable area */}
//                     <div
//                         style={{
//                             height: `calc(100vh - 75px - 60px)`,
//                             overflowY: "auto",
//                             scrollbarWidth: "none",
//                             padding: "10px",
//                         }}
//                         className=""
//                     >
//                         <style>{`
//               div::-webkit-scrollbar { 
//                 display: none; 
//               }
//             `}</style>
//                         {tabContent[activeTab]}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// // User Tab Component
// const UserTabContent = ({ 
//     data, 
//     selectedStatusFilter, 
//     setSelectedStatusFilter, 
//     selectedCategoryFilter, 
//     setSelectedCategoryFilter, 
//     filteredData, 
//     handleExport 
// }) => {
//     return (
//         <div className="user-management-container" style={{ marginTop: '0px' }}>
//             <div className="row g-2 mb-1 align-items-center me-0">
//                 <div className="col-md-auto col-12">
//                     <select
//                         className="form-select"
//                         value={selectedStatusFilter}
//                         onChange={(e) => setSelectedStatusFilter(e.target.value)}
//                         aria-label="Filter by status"
//                     >
//                         <option value="">All Status</option>
//                         <option value="true">Active</option>
//                         <option value="false">Inactive</option>
//                     </select>
//                 </div>

//                 <div className="col-md col-12">
//                     <div className="d-flex justify-content-start justify-content-md-end">
//                         <button 
//                             className="btn" 
//                             onClick={handleExport} 
//                             style={{ backgroundColor: '#b15cd6', color: '#fff' }}
//                         >
//                             Export
//                         </button>
//                     </div>
//                 </div>
//             </div>

//             <div className="user-table-wrapper" style={{ height: "500px", overflow: "auto" }}>
//                 <table style={{ width: "100%", fontSize: "0.95rem", borderCollapse: "collapse" }}>
//                     <thead>
//                         <tr>
//                             <th style={tableHeaderStyle}>S.NO</th>
//                             <th style={tableHeaderStyle}>Name</th>
//                             <th style={tableHeaderStyle}>User ID</th>
//                             <th style={tableHeaderStyle}>Email</th>
//                             <th style={tableHeaderStyle}>Phone Number</th>
//                             <th style={tableHeaderStyle}>User Type</th>
//                             <th style={tableHeaderStyle}>Status</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {filteredData.length > 0 ? (
//                             filteredData.map((user, index) => (
//                                 <tr
//                                     key={user.userId || user.sno}
//                                     style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff" }}
//                                 >
//                                     <td style={tableCellStyle}>{user.sno}</td>
//                                     <td style={tableCellStyle}>{user.userName}</td>
//                                     <td style={tableCellStyle}>{user.userId}</td>
//                                     <td style={tableCellStyle}>{user.emailId}</td>
//                                     <td style={tableCellStyle}>{user.mobileNumber}</td>
//                                     <td style={tableCellStyle}>{user.userType}</td>
//                                     <td style={tableCellStyle}>
//                                         {user.active ? "Active" : "Inactive"}
//                                     </td>
//                                 </tr>
//                             ))
//                         ) : (
//                             <tr>
//                                 <td colSpan="7" style={noDataStyle}>
//                                     {data.length === 0
//                                         ? "Loading data or no users found."
//                                         : "No users match the current filters."}
//                                 </td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </table>
//             </div>
//         </div>
//     );
// };

// // Post Paid Users Tab Component
// const PostPaidUsersTabContent = () => {
//     return (
//         <div className="post-paid-users-container" style={{ marginTop: '20px' }}>
//             <div className="text-center">
//                 <h3>Post Paid Users</h3>
//                 <p>This section is for post paid users. Content will be added here.</p>
//                 {/* You can add your post paid users table or component here */}
//             </div>
//         </div>
//     );
// };

// const tableHeaderStyle = {
//     border: "1px solid #ddd",
//     textAlign: "center",
//     fontWeight: "bold",
//     backgroundColor: "#b15cd6",
//     color: "white",
//     padding: "6px",
// };

// const tableCellStyle = {
//     border: "1px solid #ddd",
//     textAlign: "center",
//     padding: "6px",
// };

// const noDataStyle = {
//     fontStyle: "italic",
//     textAlign: "center",
//     padding: "10px",
//     color: "#888",
// };

// export default Userdetails;





















import React, { useEffect, useState, useMemo } from "react";
import "./Usermanagement.css"; // Import the CSS file
import { Link } from "react-router-dom";
import ProfessionalUser from "./ProfessionalUser";
import PostPaidUsers from "./PostPaidUsers";

const Userdetails = () => {
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [data, setData] = useState([]);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
    const [selectedCategoryFilter, setSelectedCategoryFilter] = useState("");
    const [activeTab, setActiveTab] = useState("User"); // New tab state

    // Filtered data for User tab
    const filteredData = useMemo(() => {
        return data.filter(user => {
            const statusMatch = !selectedStatusFilter ||
                user.active === (selectedStatusFilter === "true");
            const categoryMatch = !selectedCategoryFilter ||
                (user.category && user.category.toLowerCase() === selectedCategoryFilter.toLowerCase());
            return statusMatch && categoryMatch;
        });
    }, [data, selectedStatusFilter, selectedCategoryFilter]);

    // Tab content mapping
    const tabContent = {
        "User": <UserTabContent
            data={data}
            selectedStatusFilter={selectedStatusFilter}
            setSelectedStatusFilter={setSelectedStatusFilter}
            selectedCategoryFilter={selectedCategoryFilter}
            setSelectedCategoryFilter={setSelectedCategoryFilter}
            filteredData={filteredData}
        />,
        "Professional User": <ProfessionalUser />, // Using the imported component
        "Post Paid Users": <PostPaidUsers />, // New tab for Post Paid Users
    };

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const controller = new AbortController();
        const authToken = localStorage.getItem("authToken");

        const fetchUsers = async () => {
            try {
                const res = await fetch(
                    "https://backend.maamaas.com/subscription/api/admin/getallusers",
                    {
                        signal: controller.signal,
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${authToken}`,
                        },
                    }
                );

                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }

                const fetchedData = await res.json();

                // ✅ FILTER ONLY PERSONAL USERS
                const personalUsers = fetchedData.filter(
                    (item) => item.userType === "PERSONAL"
                );

                const dataWithSno = personalUsers.map((item, index) => ({
                    ...item,
                    sno: index + 1,
                    category: item.category || "N/A",
                    subscription: item.subscription || "N/A",
                    orders: typeof item.orders === "number" ? item.orders : 0,
                    last: item.lastOrderDate || item.last || "N/A",
                    statusAsDeliveryAgent:
                        item.status || item.statusAsDeliveryAgent || "N/A",
                }));

                setData(dataWithSno);
            } catch (err) {
                if (err.name !== "AbortError") {
                    console.error("Error fetching users:", err);
                }
            }
        };

        fetchUsers();

        return () => controller.abort();
    }, []);

    const openModal = (user) => setSelectedCustomer(user);
    const closeModal = () => setSelectedCustomer(null);

    return (
        <div className="container-fluid p-0 client-managment-data">
            <div className="row g-0" style={{ marginTop: '90px', height: "92vh" }}>
                <div className="col-lg-2"></div>
                <div className="col-lg-10">
                    <p
                        className="breadcrumb maamaas-home-bredcum or20"
                        style={{
                            position: "fixed",
                            top: "59px",
                            left: "1vw",
                            width: "100%",
                            backgroundColor: "#fff",
                            padding: "10px 0",
                            fontSize: "18px",
                            fontWeight: "bold",
                            textAlign: "center",
                            margin: 0,
                        }}
                    >
                        <Link
                            to="/Homes"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Home
                        </Link>

                        <span className="separator"> &gt; </span>
                        <span
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            User_Management
                        </span>
                        <span className="separator"> &gt; </span>
                        <span
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            {activeTab === "User" ? "Users" : activeTab === "Professional User" ? "Professionals" : "Post Paid Users"}
                        </span>
                    </p>

                    {/* Tab Buttons Container - Fixed position */}
                    <div className="sticky-top py-1 px-1" style={{ top: '66px' }}>
                        <div className="row g-2 justify-content-center justify-content-sm-evenly">
                            {Object.keys(tabContent).map((label) => (
                                <div className="col-auto" style={{ minWidth: '100px' }} key={label}>
                                    <button
                                        onClick={() => setActiveTab(label)}
                                        style={{
                                            border: "none",
                                            borderRadius: "10px",
                                            minWidth: "140px",
                                            width: "100%",
                                            padding: "0 10px",
                                            height: "40px",
                                            backgroundColor: activeTab === label ? "#b15cd6" : "#d9d9d9",
                                            color: activeTab === label ? "#fff" : "#000",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            transition: "background-color 0.3s ease",
                                            fontSize: "1rem",
                                        }}
                                    >
                                        {label}
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Tab Content Container - Scrollable area */}
                    <div
                        style={{
                            height: `calc(100vh - 75px - 60px)`,
                            overflowY: "auto",
                            scrollbarWidth: "none",
                            padding: "10px",
                        }}
                        className=""
                    >
                        <style>{`
              div::-webkit-scrollbar { 
                display: none; 
              }
            `}</style>
                        {tabContent[activeTab]}
                    </div>
                </div>
            </div>
        </div>
    );
};

// User Tab Component
const UserTabContent = ({
    data,
    selectedStatusFilter,
    setSelectedStatusFilter,
    selectedCategoryFilter,
    setSelectedCategoryFilter,
    filteredData
}) => {
    const [searchQuery, setSearchQuery] = useState("");

    // Filter data based on search query (User ID)
    const searchFilteredData = useMemo(() => {
        if (!searchQuery.trim()) {
            return filteredData;
        }

        const query = searchQuery.toLowerCase().trim();
        return filteredData.filter(user =>
            user.userId && user.userId.toString().toLowerCase().includes(query)
        );
    }, [filteredData, searchQuery]);

    // Fixed export function
    const handleExportFiltered = () => {
        // Use searchFilteredData instead of data
        const exportData = searchFilteredData.length > 0 ? searchFilteredData : filteredData;
        
        if (exportData.length === 0) {
            alert("There is no data to export.");
            return;
        }

        const escapeCsvField = (field) => {
            const str = String(field ?? '');
            if (str.includes(',') || str.includes('"') || str.includes('\n')) {
                return `"${str.replace(/"/g, '""')}"`;
            }
            return str;
        };

        const headers = [
            "S.NO",
            "Customer ID",
            "Name",
            "Email",
            "Phone Number",
            "Status"
        ];

        // Map the filtered data for export
        const csvRows = exportData.map((user, index) => [
            index + 1,
            user.userId || 'N/A',
            user.userName || 'N/A',
            user.emailId || 'N/A',
            user.mobileNumber || 'N/A',
            user.active ? "Active" : "Inactive"
        ]);

        const csvString = [
            headers.map(escapeCsvField).join(','),
            ...csvRows.map(row => row.map(escapeCsvField).join(','))
        ].join('\r\n');

        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "filtered_users.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    return (
        <div className="user-management-container" style={{ marginTop: '0px' }}>
            <div className="row g-2 mb-1 align-items-center me-0">
                <div className="col-md-auto col-12">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search for User ID"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{
                            border: '1px solid #ced4da',
                            maxWidth: '155px',
                            maxHeight: "40px"
                        }}
                    />
                </div>

                <div className="col-md-auto col-12">
                    <select
                        className="form-select"
                        value={selectedStatusFilter}
                        onChange={(e) => setSelectedStatusFilter(e.target.value)}
                        aria-label="Filter by status"
                        style={{ maxWidth: '150px' }}
                    >
                        <option value="">All Status</option>
                        <option value="true">Active</option>
                        <option value="false">Inactive</option>
                    </select>
                </div>

              
                <div className="col-md col-12">
                    <div className="d-flex justify-content-start justify-content-md-end">
                        <button
                            className="btn"
                            onClick={handleExportFiltered} // Use the fixed export function
                            style={{ backgroundColor: '#b15cd6', color: '#fff' }}
                        >
                            Export
                        </button>
                    </div>
                </div>
            </div>

            <div className="user-table-wrapper" style={{ height: "500px", overflow: "auto" }}>
                <table style={{ width: "100%", fontSize: "0.95rem", borderCollapse: "collapse" }}>
                    <thead>
                        <tr>
                            <th style={tableHeaderStyle}>S.NO</th>
                            <th style={tableHeaderStyle}>Name</th>
                            <th style={tableHeaderStyle}>User ID</th>
                            <th style={tableHeaderStyle}>Email</th>
                            <th style={tableHeaderStyle}>Phone Number</th>
                            <th style={tableHeaderStyle}>User Type</th>
                            <th style={tableHeaderStyle}>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {searchFilteredData.length > 0 ? (
                            searchFilteredData.map((user, index) => (
                                <tr
                                    key={user.userId || user.sno}
                                    style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff" }}
                                >
                                    <td style={tableCellStyle}>{user.sno}</td>
                                    <td style={tableCellStyle}>{user.userName}</td>
                                    <td style={tableCellStyle}>{user.userId}</td>
                                    <td style={tableCellStyle}>{user.emailId}</td>
                                    <td style={tableCellStyle}>{user.mobileNumber}</td>
                                    <td style={tableCellStyle}>{user.userType}</td>
                                    <td style={tableCellStyle}>
                                        {user.active ? "Active" : "Inactive"}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" style={noDataStyle}>
                                    {data.length === 0
                                        ? "Loading data or no users found."
                                        : searchQuery.trim()
                                            ? "No users found with the specified User ID."
                                            : "No users match the current filters."}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

// Professional User Tab Component (Already imported)
// Post Paid Users Tab Component (Already imported)

const tableHeaderStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#b15cd6",
    color: "white",
    padding: "6px",
};

const tableCellStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    padding: "6px",
};

const noDataStyle = {
    fontStyle: "italic",
    textAlign: "center",
    padding: "10px",
    color: "#888",
};

export default Userdetails;